import { IndicatorEsbStatusEnum } from "./enums/IndicatorEsbStatusEnum";

export enum IndicatorEsbEnum {
	B1 = 1,
	B2 = 2,
	B3 = 3,
	B4 = 4,
	B5 = 5,
	B6 = 6,
}

type IndicatorClassification = {
	awesome: number;
	good: number;
	enough: number;
	regular: number;
	limit: number;
	reverse?: boolean;
	notLimitted?: boolean;
};

const indicatorsClassification: Record<IndicatorEsbEnum, IndicatorClassification> = {
	[IndicatorEsbEnum.B1]: { limit: 100, awesome: 5, good: 3, enough: 1, regular: 0, notLimitted: true },
	[IndicatorEsbEnum.B2]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0, notLimitted: true },
	[IndicatorEsbEnum.B3]: {
		limit: 8,
		awesome: 10,
		good: 12,
		enough: 14,
		regular: 100,
		reverse: true,
	},
	[IndicatorEsbEnum.B4]: { limit: 100, awesome: 1, good: 0.5, enough: 0.25, regular: 0, notLimitted: true },
	[IndicatorEsbEnum.B5]: { limit: 85, awesome: 80, good: 60, enough: 40, regular: 0 },
	[IndicatorEsbEnum.B6]: { limit: 100, awesome: 8, good: 6, enough: 3, regular: 0, notLimitted: true },
};

export function getIndicatorClassificationScores(indicator: IndicatorEsbEnum) {
	return indicatorsClassification[indicator];
}

export function getIndicatorClassification(indicator: IndicatorEsbEnum, percentage: number) {
	if (indicatorsClassification[indicator].reverse) {
		if (percentage < indicatorsClassification[indicator].limit && !indicatorsClassification[indicator].notLimitted) return "Regular";
		if (percentage < indicatorsClassification[indicator].awesome) return "Ótimo";
		if (percentage < indicatorsClassification[indicator].good) return "Bom";
		if (percentage < indicatorsClassification[indicator].enough) return "Suficiente";
		return "Regular";
	}
	if (percentage > indicatorsClassification[indicator].limit && !indicatorsClassification[indicator].notLimitted) return "Regular";
	if (percentage > indicatorsClassification[indicator].awesome) return "Ótimo";
	if (percentage > indicatorsClassification[indicator].good) return "Bom";
	if (percentage > indicatorsClassification[indicator].enough) return "Suficiente";
	return "Regular";
}

export function getIndicatorClassificationColorClassName(
	indicator: IndicatorEsbEnum,
	percentage: number
) {
	if (indicatorsClassification[indicator].reverse) {
		if (percentage < indicatorsClassification[indicator].limit && !indicatorsClassification[indicator].notLimitted) return "danger";
		if (percentage < indicatorsClassification[indicator].awesome) return "primary";
		if (percentage < indicatorsClassification[indicator].good) return "success";
		if (percentage < indicatorsClassification[indicator].enough) return "warning";
		return "danger";
	}
	if (percentage > indicatorsClassification[indicator].limit && !indicatorsClassification[indicator].notLimitted) return "danger";
	if (percentage > indicatorsClassification[indicator].awesome) return "primary";
	if (percentage > indicatorsClassification[indicator].good) return "success";
	if (percentage > indicatorsClassification[indicator].enough) return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorEsb(
	citizenScoreStatus: IndicatorEsbStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEsbStatusEnum.Finished:
			return "Realizado";
		case IndicatorEsbStatusEnum.Pending:
			return "Pendente";
		case IndicatorEsbStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatus(status: IndicatorEsbStatusEnum) {
	if (status === IndicatorEsbStatusEnum.Finished) return "success";
	if (status === IndicatorEsbStatusEnum.Pending) return "warning";
	return "danger";
}
